const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-camera",
  "data-name": "Icon feather-camera",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2428",
  "data-name": "Path 2428",
  d: "M27.463,23.382a2.36,2.36,0,0,1-2.36,2.36H3.86a2.36,2.36,0,0,1-2.36-2.36V10.4A2.36,2.36,0,0,1,3.86,8.04H8.581l2.36-3.54h7.081l2.36,3.54H25.1a2.36,2.36,0,0,1,2.36,2.36Z",
  transform: "translate(-1.5 -4.5)",
  fill: "none",
  stroke: "#008941",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2429",
  "data-name": "Path 2429",
  d: "M21.441,18.221A4.721,4.721,0,1,1,16.721,13.5,4.721,4.721,0,0,1,21.441,18.221Z",
  transform: "translate(-3.739 -6.419)",
  fill: "none",
  stroke: "#008941",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));
function SvgIconfeatherCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.963,
    height: 23.243,
    viewBox: "0 0 27.963 23.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherCamera);
export default __webpack_public_path__ + "static/media/Icon feather-camera.c2f7bfe1.svg";
export { ForwardRef as ReactComponent };